/** @ngInject */
export function Controller($rootScope, $state, $uibModal) {

    $uibModal.open({component: 'sessionExpired'}).result.finally(() => {
        $rootScope.authenticationError = false;
        $state.go('public.login');
    });
}



// WEBPACK FOOTER //
// ./src/portal/states/public/session-expired/session-expired.controller.js